unit unit_EinzelAnsprechpartner;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, WEBLib.StdCtrls, WEBLib.Buttons, Vcl.StdCtrls,
  WEBLib.DBCtrls, Vcl.Controls, WEBLib.ExtCtrls, Data.DB, WEBLib.DB,
  XData.Web.JsonDataset, XData.Web.Dataset, WEBLib.Grids, strutils,
  WEBLib.ComCtrls, XData.Web.Client, DB;

type
  TEinzelAnsprechpartner = class(TForm)
    xdsEinzelAP: TXDataWebDataSet;
    TC: TTableControl;
    WClient: TXDataWebClient;
    Container1: THTMLContainer;
    Container2: THTMLContainer;
    btnzurueck: TButton;
    Container3: THTMLContainer;
    xdsEinzelAPKundennummerKundennummer: TStringField;
    xdsEinzelAPKundennummerNachname: TStringField;
    xdsEinzelAPAnsprechpartner: TStringField;
    xdsEinzelAPAbteilung: TStringField;
    xdsEinzelAPNachname: TStringField;
    xdsEinzelAPVorname: TStringField;
    xdsEinzelAPTelefonNummer: TStringField;
    xdsEinzelAPTelefonDurchwahl: TStringField;
    xdsEinzelAPTelefaxNummer: TStringField;
    xdsEinzelAPMobilTelefon: TStringField;
    xdsEinzelAPEMail: TStringField;
    xdsEinzelAPInternet: TStringField;
    xdsEinzelAPGeburtstag: TDateTimeField;
    xdsEinzelAPBemerkung: TStringField;
    xdsEinzelAPKeinNewsletter: TBooleanField;
    xdsEinzelAPAdresseBild: TStringField;
    xdsEinzelAPBriefanrede1: TStringField;
    xdsEinzelAPTitel: TStringField;
    xdsEinzelAPAPID: TStringField;
    xdsEinzelAPAnrede: TStringField;
    procedure xdsEinzelAPAfterOpen(DataSet: TDataSet);
    procedure WebFormShow(Sender: TObject);
    procedure btnzurueckClick(Sender: TObject);
  private
    { Private-Deklarationen }
  public
    { Public-Deklarationen }
    APID:string;
    BemerkungenText:string;
    procedure fensteraufbauen;
  protected procedure LoadDFMValues; override; end;

var
  EinzelAnsprechpartner: TEinzelAnsprechpartner;

implementation
  uses unit1, unit2, unit_ListeAnsprechpartner;
{$R *.dfm}



procedure TEinzelAnsprechpartner.btnzurueckClick(Sender: TObject);
begin
  xdsEinzelAP.Close;
  self.Close;
end;



procedure TEinzelAnsprechpartner.WebFormShow(Sender: TObject);
var
  myelement:TJSHTMLElement;
begin
  Container1.html.text:='<nav class="navbar m-1 rounded bg-info"><h5>Einzel-Ansprechpartner</h5></nav>';
  myelement:=container1.ElementHandle;
  container2.ParentElement:=myelement;
  container3.ParentElement:=myelement;
  myelement:=container2.ElementHandle;
  btnzurueck.ParentElement:=myelement;

  myelement:=container2.ElementHandle;
  tc.ParentElement:=myElement;
  xdsEinzelAP.Close;
  xdseinzelAP.QueryString:='$expand=Kundennummer&$filter=APID eq '+quotedstr(APID);
  xdseinzelAP.Load;
end;

procedure TEinzelAnsprechpartner.xdsEinzelAPAfterOpen(DataSet: TDataSet);

  procedure OnResponse(Response:TXDataClientResponse);
  var
    mydownload:string;
  begin
    mydownload:=string(TJSObject(response.Result)['value']);
    BemerkungenText:=ReplaceStr(mydownload,#13+#10,'<BR>');
    fensteraufbauen;


  end;
begin
  WClient.RawInvoke('IServerService.RTFTOTEXT',[xdsEinzelAPBemerkung.AsString],@OnResponse);
end;

procedure TEinzelAnsprechpartner.fensteraufbauen;
var
  i:integer;
  myelement:TJSHTMLElement;
begin
  TC.Visible:=true;
  TC.RowCount:=19;
  TC.ColCount:=2;
  i:=0;

  TC.Cells[0,i]:='Kontakt-/Kundennummer';
  TC.Cells[1,i]:='<h5>'+xdsEinzelAPKundennummerKundennummer.asstring+' '+xdsEinzelAPKundennummerNachname.asstring;
  inc(i);
  TC.Cells[0,i]:='Ansprechpartner';
  TC.Cells[1,i]:='<h5>'+xdsEinzelAPAnsprechpartner.asstring;
  inc(i);
  TC.Cells[0,i]:='Nachname';
  TC.Cells[1,i]:='<h5>'+xdsEinzelAPNachname.asstring;
  inc(i);
  TC.Cells[0,i]:='Vorname';
  TC.Cells[1,i]:='<h5>'+xdsEinzelAPVorname.asstring;
  inc(i);
  TC.Cells[0,i]:='Anrede';
  TC.Cells[1,i]:=xdsEinzelAPAnrede.Asstring;
  inc(i);
  TC.Cells[0,i]:='Titel';
  TC.Cells[1,i]:=xdsEinzelAPTitel.Asstring;
  inc(i);
  TC.Cells[0,i]:='Abteilung';
  TC.Cells[1,i]:=xdsEinzelAPAbteilung.Asstring;
  inc(i);
  TC.Cells[0,i]:='Anschrift';
  TC.Cells[1,i]:='<h5>'+ReplaceStr(xdsEinzelAPAdresseBild.asstring,#13+#10,'<BR>');
  inc(i);
  TC.Cells[0,i]:='Telefon';
  TC.Cells[1,i]:='<a href="tel:'+xdsEinzelAPTelefonnummer.Asstring+'">'+xdsEinzelAPTelefonnummer.Asstring+'</a>';
  inc(i);
  TC.Cells[0,i]:='T-Durchwahl';
  TC.Cells[1,i]:='<a href="tel:'+xdsEinzelAPTelefonDurchwahl.Asstring+'">'+xdsEinzelAPTelefonDurchwahl.Asstring+'</a>';
  inc(i);
  TC.Cells[0,i]:='Mobil';
  TC.Cells[1,i]:='<a href="tel:'+xdsEinzelAPMobilTelefon.Asstring+'">'+xdsEinzelAPMobilTelefon.Asstring+'</a>';
  inc(i);
  TC.Cells[0,i]:='Telefax';
  TC.Cells[1,i]:=xdsEinzelAPTelefaxNummer.Asstring;
  inc(i);
  TC.Cells[0,i]:='Email';
  TC.Cells[1,i]:='<a href="mailto:'+xdsEinzelAPEMail.Asstring+'">'+xdsEinzelAPEMail.AsString+'</a>';
  inc(i);
  TC.Cells[0,i]:='Webseite';
  TC.Cells[1,i]:='<a href="http://'+xdsEinzelapInternet.Asstring+'" target="_blank">'+xdsEinzelAPInternet.AsString+'</a>';
  inc(i);
  TC.Cells[0,i]:='Briefanrede';
  TC.Cells[1,i]:=xdsEinzelAPBriefanrede1.Asstring;
  inc(i);
  TC.Cells[0,i]:='Geburtstag';
  if xdsEinzelAPGeburtstag.AsString<>'' then TC.Cells[1,i]:=formatdatetime('DD.MM.YYYY',xdsEinzelAPGeburtstag.asdatetime);
  inc(i);
  TC.Cells[0,i]:='Newsletter';
  if xdsEinzelAPKeinNewsletter.AsBoolean=true then TC.Cells[1,i]:='kein Newsletter' else TC.Cells[1,i]:='Ja';
  inc(i);
  TC.Cells[0,i]:='Bemerkung';
  TC.Cells[1,i]:=BemerkungenText;

  end;


procedure TEinzelAnsprechpartner.LoadDFMValues;
begin
  inherited LoadDFMValues;

  TC := TTableControl.Create(Self);
  Container1 := THTMLContainer.Create(Self);
  Container2 := THTMLContainer.Create(Self);
  btnzurueck := TButton.Create(Self);
  Container3 := THTMLContainer.Create(Self);
  xdsEinzelAP := TXDataWebDataSet.Create(Self);
  xdsEinzelAPKundennummerKundennummer := TStringField.Create(Self);
  xdsEinzelAPKundennummerNachname := TStringField.Create(Self);
  xdsEinzelAPAnsprechpartner := TStringField.Create(Self);
  xdsEinzelAPAbteilung := TStringField.Create(Self);
  xdsEinzelAPNachname := TStringField.Create(Self);
  xdsEinzelAPVorname := TStringField.Create(Self);
  xdsEinzelAPTelefonNummer := TStringField.Create(Self);
  xdsEinzelAPTelefonDurchwahl := TStringField.Create(Self);
  xdsEinzelAPTelefaxNummer := TStringField.Create(Self);
  xdsEinzelAPMobilTelefon := TStringField.Create(Self);
  xdsEinzelAPEMail := TStringField.Create(Self);
  xdsEinzelAPInternet := TStringField.Create(Self);
  xdsEinzelAPGeburtstag := TDateTimeField.Create(Self);
  xdsEinzelAPBemerkung := TStringField.Create(Self);
  xdsEinzelAPKeinNewsletter := TBooleanField.Create(Self);
  xdsEinzelAPAdresseBild := TStringField.Create(Self);
  xdsEinzelAPBriefanrede1 := TStringField.Create(Self);
  xdsEinzelAPTitel := TStringField.Create(Self);
  xdsEinzelAPAPID := TStringField.Create(Self);
  xdsEinzelAPAnrede := TStringField.Create(Self);
  WClient := TXDataWebClient.Create(Self);

  TC.BeforeLoadDFMValues;
  Container1.BeforeLoadDFMValues;
  Container2.BeforeLoadDFMValues;
  btnzurueck.BeforeLoadDFMValues;
  Container3.BeforeLoadDFMValues;
  xdsEinzelAP.BeforeLoadDFMValues;
  xdsEinzelAPKundennummerKundennummer.BeforeLoadDFMValues;
  xdsEinzelAPKundennummerNachname.BeforeLoadDFMValues;
  xdsEinzelAPAnsprechpartner.BeforeLoadDFMValues;
  xdsEinzelAPAbteilung.BeforeLoadDFMValues;
  xdsEinzelAPNachname.BeforeLoadDFMValues;
  xdsEinzelAPVorname.BeforeLoadDFMValues;
  xdsEinzelAPTelefonNummer.BeforeLoadDFMValues;
  xdsEinzelAPTelefonDurchwahl.BeforeLoadDFMValues;
  xdsEinzelAPTelefaxNummer.BeforeLoadDFMValues;
  xdsEinzelAPMobilTelefon.BeforeLoadDFMValues;
  xdsEinzelAPEMail.BeforeLoadDFMValues;
  xdsEinzelAPInternet.BeforeLoadDFMValues;
  xdsEinzelAPGeburtstag.BeforeLoadDFMValues;
  xdsEinzelAPBemerkung.BeforeLoadDFMValues;
  xdsEinzelAPKeinNewsletter.BeforeLoadDFMValues;
  xdsEinzelAPAdresseBild.BeforeLoadDFMValues;
  xdsEinzelAPBriefanrede1.BeforeLoadDFMValues;
  xdsEinzelAPTitel.BeforeLoadDFMValues;
  xdsEinzelAPAPID.BeforeLoadDFMValues;
  xdsEinzelAPAnrede.BeforeLoadDFMValues;
  WClient.BeforeLoadDFMValues;
  try
    Name := 'EinzelAnsprechpartner';
    Width := 223;
    Height := 393;
    CSSLibrary := cssBootstrap;
    ElementFont := efCSS;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    TC.SetParentComponent(Self);
    TC.Name := 'TC';
    TC.Left := 32;
    TC.Top := 251;
    TC.Width := 152;
    TC.Height := 110;
    TC.ElementClassName := 'table table-hover table-bordered table-striped';
    TC.HeightStyle := ssAuto;
    TC.WidthStyle := ssPercent;
    TC.BorderColor := clSilver;
    TC.ColHeader := False;
    TC.ElementFont := efCSS;
    TC.ElementHeaderClassName := 'table-info';
    TC.ElementPosition := epIgnore;
    TC.ElementTableClassName := 'table table-hover table-bordered table-striped';
    TC.WordWrap := True;
    TC.ColCount := 2;
    Container1.SetParentComponent(Self);
    Container1.Name := 'Container1';
    Container1.Left := 0;
    Container1.Top := 0;
    Container1.Width := 169;
    Container1.Height := 41;
    Container1.HeightStyle := ssAuto;
    Container1.WidthStyle := ssPercent;
    Container1.ChildOrder := 4;
    Container1.ElementFont := efCSS;
    Container1.ElementPosition := epIgnore;
    Container2.SetParentComponent(Self);
    Container2.Name := 'Container2';
    Container2.Left := 0;
    Container2.Top := 47;
    Container2.Width := 169;
    Container2.Height := 41;
    Container2.ElementClassName := 'd-flex flex-wrap m-1';
    Container2.HeightStyle := ssAuto;
    Container2.WidthStyle := ssAuto;
    Container2.ChildOrder := 1;
    Container2.ElementFont := efCSS;
    Container2.ElementPosition := epIgnore;
    btnzurueck.SetParentComponent(Self);
    btnzurueck.Name := 'btnzurueck';
    btnzurueck.Left := 0;
    btnzurueck.Top := 158;
    btnzurueck.Width := 96;
    btnzurueck.Height := 25;
    btnzurueck.Caption := '<< zur'#252'ck';
    btnzurueck.ChildOrder := 4;
    btnzurueck.ElementClassName := 'btn btn-info btn-sm m-1 text-left';
    btnzurueck.ElementFont := efCSS;
    btnzurueck.ElementPosition := epIgnore;
    btnzurueck.HeightStyle := ssAuto;
    btnzurueck.HeightPercent := 100.000000000000000000;
    btnzurueck.WidthStyle := ssAuto;
    btnzurueck.WidthPercent := 100.000000000000000000;
    SetEvent(btnzurueck, Self, 'OnClick', 'btnzurueckClick');
    Container3.SetParentComponent(Self);
    Container3.Name := 'Container3';
    Container3.Left := 0;
    Container3.Top := 94;
    Container3.Width := 169;
    Container3.Height := 41;
    Container3.ElementClassName := 'd-flex flex-wrap m-1';
    Container3.HeightStyle := ssAuto;
    Container3.WidthStyle := ssAuto;
    Container3.ChildOrder := 1;
    Container3.ElementFont := efCSS;
    Container3.ElementPosition := epIgnore;
    xdsEinzelAP.SetParentComponent(Self);
    xdsEinzelAP.Name := 'xdsEinzelAP';
    xdsEinzelAP.AfterOpen := xdsEinzelAPAfterOpen;
    xdsEinzelAP.EntitySetName := 'Ansprechpartner';
    xdsEinzelAP.Connection := DM2.XDataWebConnection1;
    xdsEinzelAP.SubpropsDepth := 1;
    xdsEinzelAP.QueryTop := 1;
    xdsEinzelAP.Left := 20;
    xdsEinzelAP.Top := 125;
    xdsEinzelAPKundennummerKundennummer.SetParentComponent(xdsEinzelAP);
    xdsEinzelAPKundennummerKundennummer.Name := 'xdsEinzelAPKundennummerKundennummer';
    xdsEinzelAPKundennummerKundennummer.FieldName := 'Kundennummer.Kundennummer';
    xdsEinzelAPKundennummerKundennummer.Size := 13;
    xdsEinzelAPKundennummerNachname.SetParentComponent(xdsEinzelAP);
    xdsEinzelAPKundennummerNachname.Name := 'xdsEinzelAPKundennummerNachname';
    xdsEinzelAPKundennummerNachname.FieldName := 'Kundennummer.Nachname';
    xdsEinzelAPKundennummerNachname.Size := 40;
    xdsEinzelAPAnsprechpartner.SetParentComponent(xdsEinzelAP);
    xdsEinzelAPAnsprechpartner.Name := 'xdsEinzelAPAnsprechpartner';
    xdsEinzelAPAnsprechpartner.FieldName := 'Ansprechpartner';
    xdsEinzelAPAnsprechpartner.Size := 50;
    xdsEinzelAPAbteilung.SetParentComponent(xdsEinzelAP);
    xdsEinzelAPAbteilung.Name := 'xdsEinzelAPAbteilung';
    xdsEinzelAPAbteilung.FieldName := 'Abteilung';
    xdsEinzelAPAbteilung.Size := 50;
    xdsEinzelAPNachname.SetParentComponent(xdsEinzelAP);
    xdsEinzelAPNachname.Name := 'xdsEinzelAPNachname';
    xdsEinzelAPNachname.FieldName := 'Nachname';
    xdsEinzelAPNachname.Size := 40;
    xdsEinzelAPVorname.SetParentComponent(xdsEinzelAP);
    xdsEinzelAPVorname.Name := 'xdsEinzelAPVorname';
    xdsEinzelAPVorname.FieldName := 'Vorname';
    xdsEinzelAPVorname.Size := 40;
    xdsEinzelAPTelefonNummer.SetParentComponent(xdsEinzelAP);
    xdsEinzelAPTelefonNummer.Name := 'xdsEinzelAPTelefonNummer';
    xdsEinzelAPTelefonNummer.FieldName := 'TelefonNummer';
    xdsEinzelAPTelefonNummer.Size := 25;
    xdsEinzelAPTelefonDurchwahl.SetParentComponent(xdsEinzelAP);
    xdsEinzelAPTelefonDurchwahl.Name := 'xdsEinzelAPTelefonDurchwahl';
    xdsEinzelAPTelefonDurchwahl.FieldName := 'TelefonDurchwahl';
    xdsEinzelAPTelefonDurchwahl.Size := 10;
    xdsEinzelAPTelefaxNummer.SetParentComponent(xdsEinzelAP);
    xdsEinzelAPTelefaxNummer.Name := 'xdsEinzelAPTelefaxNummer';
    xdsEinzelAPTelefaxNummer.FieldName := 'TelefaxNummer';
    xdsEinzelAPTelefaxNummer.Size := 25;
    xdsEinzelAPMobilTelefon.SetParentComponent(xdsEinzelAP);
    xdsEinzelAPMobilTelefon.Name := 'xdsEinzelAPMobilTelefon';
    xdsEinzelAPMobilTelefon.FieldName := 'MobilTelefon';
    xdsEinzelAPMobilTelefon.Size := 25;
    xdsEinzelAPEMail.SetParentComponent(xdsEinzelAP);
    xdsEinzelAPEMail.Name := 'xdsEinzelAPEMail';
    xdsEinzelAPEMail.FieldName := 'EMail';
    xdsEinzelAPEMail.Size := 50;
    xdsEinzelAPInternet.SetParentComponent(xdsEinzelAP);
    xdsEinzelAPInternet.Name := 'xdsEinzelAPInternet';
    xdsEinzelAPInternet.FieldName := 'Internet';
    xdsEinzelAPInternet.Size := 50;
    xdsEinzelAPGeburtstag.SetParentComponent(xdsEinzelAP);
    xdsEinzelAPGeburtstag.Name := 'xdsEinzelAPGeburtstag';
    xdsEinzelAPGeburtstag.FieldName := 'Geburtstag';
    xdsEinzelAPBemerkung.SetParentComponent(xdsEinzelAP);
    xdsEinzelAPBemerkung.Name := 'xdsEinzelAPBemerkung';
    xdsEinzelAPBemerkung.FieldName := 'Bemerkung';
    xdsEinzelAPBemerkung.Size := 255;
    xdsEinzelAPKeinNewsletter.SetParentComponent(xdsEinzelAP);
    xdsEinzelAPKeinNewsletter.Name := 'xdsEinzelAPKeinNewsletter';
    xdsEinzelAPKeinNewsletter.FieldName := 'KeinNewsletter';
    xdsEinzelAPAdresseBild.SetParentComponent(xdsEinzelAP);
    xdsEinzelAPAdresseBild.Name := 'xdsEinzelAPAdresseBild';
    xdsEinzelAPAdresseBild.FieldName := 'AdresseBild';
    xdsEinzelAPAdresseBild.Size := 255;
    xdsEinzelAPBriefanrede1.SetParentComponent(xdsEinzelAP);
    xdsEinzelAPBriefanrede1.Name := 'xdsEinzelAPBriefanrede1';
    xdsEinzelAPBriefanrede1.FieldName := 'Briefanrede1';
    xdsEinzelAPBriefanrede1.Size := 255;
    xdsEinzelAPTitel.SetParentComponent(xdsEinzelAP);
    xdsEinzelAPTitel.Name := 'xdsEinzelAPTitel';
    xdsEinzelAPTitel.FieldName := 'Titel';
    xdsEinzelAPAPID.SetParentComponent(xdsEinzelAP);
    xdsEinzelAPAPID.Name := 'xdsEinzelAPAPID';
    xdsEinzelAPAPID.FieldName := 'APID';
    xdsEinzelAPAPID.Required := True;
    xdsEinzelAPAPID.Size := 38;
    xdsEinzelAPAnrede.SetParentComponent(xdsEinzelAP);
    xdsEinzelAPAnrede.Name := 'xdsEinzelAPAnrede';
    xdsEinzelAPAnrede.FieldName := 'Anrede';
    xdsEinzelAPAnrede.Size := 15;
    WClient.SetParentComponent(Self);
    WClient.Name := 'WClient';
    WClient.Connection := DM2.XDataWebConnection1;
    WClient.Left := 24;
    WClient.Top := 8;
  finally
    TC.AfterLoadDFMValues;
    Container1.AfterLoadDFMValues;
    Container2.AfterLoadDFMValues;
    btnzurueck.AfterLoadDFMValues;
    Container3.AfterLoadDFMValues;
    xdsEinzelAP.AfterLoadDFMValues;
    xdsEinzelAPKundennummerKundennummer.AfterLoadDFMValues;
    xdsEinzelAPKundennummerNachname.AfterLoadDFMValues;
    xdsEinzelAPAnsprechpartner.AfterLoadDFMValues;
    xdsEinzelAPAbteilung.AfterLoadDFMValues;
    xdsEinzelAPNachname.AfterLoadDFMValues;
    xdsEinzelAPVorname.AfterLoadDFMValues;
    xdsEinzelAPTelefonNummer.AfterLoadDFMValues;
    xdsEinzelAPTelefonDurchwahl.AfterLoadDFMValues;
    xdsEinzelAPTelefaxNummer.AfterLoadDFMValues;
    xdsEinzelAPMobilTelefon.AfterLoadDFMValues;
    xdsEinzelAPEMail.AfterLoadDFMValues;
    xdsEinzelAPInternet.AfterLoadDFMValues;
    xdsEinzelAPGeburtstag.AfterLoadDFMValues;
    xdsEinzelAPBemerkung.AfterLoadDFMValues;
    xdsEinzelAPKeinNewsletter.AfterLoadDFMValues;
    xdsEinzelAPAdresseBild.AfterLoadDFMValues;
    xdsEinzelAPBriefanrede1.AfterLoadDFMValues;
    xdsEinzelAPTitel.AfterLoadDFMValues;
    xdsEinzelAPAPID.AfterLoadDFMValues;
    xdsEinzelAPAnrede.AfterLoadDFMValues;
    WClient.AfterLoadDFMValues;
  end;
end;

end.
